import React from 'react';
import styled from 'styled-components';
import { BadgeType } from '@contracts';
import Badge from './Badge';
import { StyledSimpleBoxWrapper } from './SharedStyles';

interface SimpleBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  selectable?: boolean;
  selected?: boolean;
  badgeType?: BadgeType;
  badgeText?: string;
  isHighlighted?: boolean;
  isRadioSelection?: boolean;
  flexDirection?: string;
  onClick?: (event?: React.MouseEvent) => void;
  children: React.ReactNode;
}

const SimpleBox: React.FC<SimpleBoxProps> = ({
  selectable,
  selected,
  badgeText,
  badgeType,
  isHighlighted,
  isRadioSelection,
  children,
  flexDirection,
  onClick
}) => {
  return (
    <BoxContainer
      $selectable={selectable}
      $isSelected={selected}
      $isHighlighted={isHighlighted}
      $isRadioSelection={isRadioSelection}
      $flexDirection={flexDirection}
      onClick={onClick}
      className="simple-box"
    >
      {badgeText && (
        <BadgeWrapper $selected={selected}>
          <Badge text={badgeText} type={`${badgeType} small`} />
        </BadgeWrapper>
      )}
      <ContentWrapper className="simple-box-content" $flexDirection={flexDirection}>
        {children}
      </ContentWrapper>
    </BoxContainer>
  );
};

const BoxContainer = styled(StyledSimpleBoxWrapper)`
  padding: 16px;
  position: relative;
`;

const BadgeWrapper = styled.div<{ $selected?: boolean }>`
  display: flex;
  position: absolute;
  top: -8px;
  right: 16px;
`;

interface ContentWrapperStyled {
  $flexDirection?: string;
}

const ContentWrapper = styled.div<ContentWrapperStyled>`
  display: flex;
  flex-direction: ${(props) => props.$flexDirection || 'column'};
`;

export default SimpleBox;
